// extracted by mini-css-extract-plugin
export default {"descriptionText":"subAuto_descriptionText__Zrrcq","buttonContainer":"subAuto_buttonContainer__dSoBl"};